import { CSSProperties } from 'react';

import { AppColors } from './../../theme';

type SearchBarStyle = {
  searchBar: CSSProperties;
  searchBar__select: CSSProperties;
  searchBar__input: CSSProperties;
  searchBar__icon: CSSProperties;
  searchBar__errorStatus: CSSProperties;
  searchBar__error: CSSProperties;
  searchBar__selectIcon: CSSProperties;
  searchBar__fullInput: CSSProperties;
};

const styles: SearchBarStyle = {
  searchBar: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  searchBar__select: {
    width: '128px',
    borderRadius: 8,
    borderStartEndRadius: 0,
    borderEndEndRadius: 0
  },
  searchBar__input: {
    width: '100%',
    borderRadius: 8,
    borderStartStartRadius: 0,
    borderEndStartRadius: 0,
    marginRight: 12
  },
  searchBar__icon: {
    border: 'none',
    background: 'transparent',
    padding: '0',
    cursor: 'pointer',
    color: AppColors.VA.NEUTRALS._60_,
    transition: 'color 0.2s ease-in-out'
  },
  searchBar__errorStatus: {
    borderColor: AppColors.VA.ERROR._50_
  },
  searchBar__error: {
    color: AppColors.VA.ERROR._50_,
    fontSize: '12px',
    marginTop: '4px',
    paddingLeft: '8px',
    width: '100%',
    whiteSpace: 'normal',
    wordWrap: 'break-word'
  },
  searchBar__selectIcon: {
    fontSize: '18px',
    color: AppColors.VA.PRIMARY._50_
  },
  searchBar__fullInput: {
    flex: 1,
    padding: '0 16px',
    backgroundColor: 'transparent',
    fontSize: '14px',
    height: '100%',
    borderStartStartRadius: 8,
    borderEndStartRadius: 8
  }
};

export default styles;
